<template>
  <hm-content>
    <div class="table-panel flex flex-end">
      <div>
        <!-- <el-input
          clearable
          style="width:250px"
          v-model.trim="searchCondition.keyword"
          placeholder="请输入手机号/卡号/姓名/昵称"
          size="small"
          class="ipt mr10"
        ></el-input> -->
        <el-input
          clearable
          style="width:300px"
          v-model.trim="searchCondition.keyword"
          :placeholder="placeholder"
          size="small"
          class="ipt mr10"
        >
          <el-select
            slot="prepend"
            size="small"
            style="width:100px"
            @change="selectQueryType"
            v-model="searchCondition.queryType"
          >
            <el-option label="手机号" value="cardMobile"></el-option>
            <!-- <el-option label="会员名称" value="memberName"></el-option> -->
            <el-option label="会员卡" value="cardNo"></el-option>
            <el-option label="会员名称" value="fullName"></el-option>
          </el-select>
        </el-input>
        <!-- <el-select
          clearable
          class="mr10"
          size="small"
          v-model="searchCondition.belongShopId"
          placeholder="请选择所属门店"
          filterable
        >
          <el-option
            :label="v.shopName"
            :value="v.shopId"
            :key="i"
            v-for="(v, i) in shopList.records"
          ></el-option>
        </el-select> -->
        <!-- <el-select
          clearable
          class="mr10"
          size="small"
          v-model="searchCondition.belongEmployeeId"
          placeholder="请输入所属导购姓名"
          filterable
        >
          <el-option
            :label="v.realname"
            :value="v.employeeId"
            :key="i"
            v-for="(v, i) in allEmployeeList.records"
          ></el-option>
        </el-select> -->
        <el-date-picker
          clearable
          :default-time="['00:00:00', '23:59:59']"
          v-model="searchCondition.cardBirthdayArry"
          type="datetimerange"
          align="right"
          start-placeholder="请选择生日时间段"
          end-placeholder="请选择生日时间段"
          value-format="yyyy-MM-dd HH:mm:ss"
          size="small"
          class="mr10"
        ></el-date-picker>
        <el-date-picker
          clearable
          :default-time="['00:00:00', '23:59:59']"
          v-model="searchCondition.createTimeArry"
          type="datetimerange"
          align="right"
          start-placeholder="请选择开卡时间段"
          end-placeholder="请选择开卡时间段"
          value-format="yyyy-MM-dd HH:mm:ss"
          size="small"
          class="mr10"
        ></el-date-picker>
        <el-select
          clearable
          class="mr10"
          size="small"
          v-model="searchCondition.cardTypeId"
          placeholder="请选择卡类型"
          filterable
        >
          <el-option
            :label="v.typeName"
            :value="v.cardTypeId"
            :key="i"
            v-for="(v, i) in cardTypeList"
          ></el-option>
        </el-select>
        <el-button type="primary" size="small" @click="search">查询</el-button>
      </div>
    </div>
    <div class="table">
      <div class="flex batch flex-between mb10">
        <!-- <div>
          <span>已选{{ num }}条</span>
        </div> -->
        <!-- <div @click="batchSetting" class="pointer">
          <span class="delete-icon hmicon icon-xitong"></span>
          批量分配
        </div> -->
      </div>
      <el-table
        @current-change="handleCurrentChange"
        @selection-change="getChecked"
        :data="vipCardList.records"
        style="width: 100%"
        stripe
        size="small"
        border
      >
        <el-table-column type="selection"></el-table-column>

        <el-table-column
          header-align="center"
          align="center"
          type="index"
          label="序号"
          width="50"
          :index="index => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="会员卡号"
          prop="cardNo"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="typeName"
          label="会员卡类型"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="fullName"
          label="会员姓名"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="cardMobile"
          label="会员手机号"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="currentIntegral"
          label="积分"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="currentBalance"
          label="卡余额"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="cardBirthday"
          label="生日"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="opencardTime"
          label="注册时间"
          width="180"
        ></el-table-column>
        <!-- <el-table-column
          header-align="center"
          align="center"
          prop="shopName"
          label="所属门店"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="realName"
          label="归属导购"
        ></el-table-column> -->
        <el-table-column
          header-align="center"
          align="center"
          prop="cardState"
          label="状态"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.cardState == 'yes'" class="success"
              >正常</span
            >
            <span v-else class="danger">冻结</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="hm-pagination">
      <el-pagination
        background
        :total="vipCardList.total"
        @current-change="paging"
        @size-change="handleSizeChange"
        layout="total, sizes, prev, pager, next, jumper"
        :current-page="currentPage"
        :page-size="pageSize"
      ></el-pagination>
    </div>
    <el-dialog
      :close-on-click-modal="false"
      title="批量设置"
      :visible.sync="dialogVisible"
    >
      <div class="table-panel flex flex-end">
        <div>
          <el-input
            style="width:249px"
            size="small"
            type="text"
            placeholder="请输入导购账号/名称"
            class="mr10"
            v-model.trim="keyWords"
          ></el-input>
          <el-button type="primary" size="small" @click="searchGuider"
            >查询</el-button
          >
        </div>
      </div>
      <div class="table mb10">
        <div class="tips mb20">提示：点击表格行即可选择</div>
        <el-table
          @current-change="getCheckedEmployee"
          :data="allEmployeeList.records"
          highlight-current-row
          style="width: 100%"
          stripe
          size="small"
          border
        >
          <el-table-column
            header-align="center"
            align="center"
            type="index"
            label="序号"
            width="50"
            :index="index => index + (currentEmployeePage - 1) * 10 + 1"
          ></el-table-column>

          <el-table-column
            header-align="center"
            align="center"
            label="用户账号"
            prop="username"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="realname"
            label="用户名称"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="categoryLogo"
            label="状态"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.workingState == 'yes'" class="success"
                >在职</span
              >
              <span v-else class="danger">离职</span>
            </template>
          </el-table-column>
        </el-table>
        <div class="hm-pagination">
          <el-pagination
            background
            :total="allEmployeeList.total"
            @current-change="pagingEmployee"
            @size-change="handleSizeEmployeeChange"
            layout="total, sizes, prev, pager, next, jumper"
            :current-page="currentEmployeePage"
          ></el-pagination>
        </div>
      </div>
      <div class="btn-wrapper flex flex-center">
        <el-button size="small" type="primary" @click="save">确 定</el-button>
        <el-button size="small" @click="dialogVisible = false">取 消</el-button>
      </div>
    </el-dialog>
  </hm-content>
</template>

<script>
import { mapGetters } from "vuex";
import { setCookie, getCookie } from "@/utils/utils";
export default {
  data() {
    return {
      num: 0,
      currentRow: {},
      searchCondition: {
        queryType: "cardMobile"
      },
      checkedRow: [],
      checkedEmployee: [],
      currentPage: 1,
      dialogVisible: false,
      pageSize: 10,
      currentEmployeePage: 1,
      pageEmployeeSize: 10,
      belongEmployeeId: "",
      keyWords: "",
      placeholder: "请输入手机号"
    };
  },
  computed: mapGetters([
    "vipCardList",
    "shopList",
    "allEmployeeList",
    "cardTypeList"
  ]),
  watch: {
    // "vipCardList.total": {
    //   handler(val) {
    //     if (
    //       val == (this.currentPage - 1) * this.pageSize &&
    //       this.pageTotal != 0
    //     ) {
    //       this.currentPage -= 1;
    //       // this.queryList();
    //     }
    //   },
    //   deep: true
    // }
  },
  created() {},
  mounted() {
    this.getParamsCookie();
    this.queryList();
    this.queryShopList();
    this.queryEmployeeList();
    this.queryCardTypeList();
  },
  methods: {
    selectQueryType(queryType) {
      if (queryType === "cardMobile") {
        this.placeholder = "请输入手机号";
      } else if (queryType === "fullName") {
        this.placeholder = "请输入会员名称";
      } else if (queryType === "cardNo") {
        this.placeholder = "请输入会员卡号";
      }
    },
    handleCurrentChange(row) {
      this.currentRow = row;
    },
    searchGuider() {
      this.queryEmployeeList();
    },
    save() {
      let params = {};
      params.belongEmployeeId = this.checkedEmployee;
      params.memberCardIds = this.checkedRow;
      this.$store.dispatch("batchAllocation", params).then(res => {
        if (res.code == 0) {
          this.dialogVisible = false;
          this.queryList();
        }
      });
    },
    queryCardTypeList() {
      this.$store.dispatch("queryCardTypeList", {
        pageNo: 1,
        pageSize: 99999
      });
    },
    queryEmployeeList() {
      this.$store.dispatch("queryEmployeeList", {
        pageNo: 1,
        pageSize: 99999,
        workingState: "yes",
        queryKey: this.keyWords,
        loginType: "store"
      });
    },
    queryShopList() {
      this.$store.dispatch("queryShopList", {
        pageNo: 1,
        pageSize: 99999
      });
    },
    queryList() {
      const params = {
        pageNo: this.currentPage,
        pageSize: this.pageSize
      };
      this.setParamsCookie();
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      searchCondition.cardBirthdayStart =
        this.searchCondition.cardBirthdayArry &&
        this.searchCondition.cardBirthdayArry.length > 0
          ? this.searchCondition.cardBirthdayArry[0]
          : null;
      searchCondition.cardBirthdayEnd =
        this.searchCondition.cardBirthdayArry &&
        this.searchCondition.cardBirthdayArry.length > 0
          ? this.searchCondition.cardBirthdayArry[1]
          : null;
      searchCondition.createTimeStart =
        this.searchCondition.createTimeArry &&
        this.searchCondition.createTimeArry.length > 0
          ? this.searchCondition.createTimeArry[0]
          : null;
      searchCondition.createTimeEnd =
        this.searchCondition.createTimeArry &&
        this.searchCondition.createTimeArry.length > 0
          ? this.searchCondition.createTimeArry[1]
          : null;
      Object.assign(params, searchCondition);

      this.$store.dispatch("queryVipCardList", params);
    },
    setParamsCookie() {
      setCookie({
        key: "vipCardListParams",
        type: "session",
        data: Object.assign({}, this.searchCondition, {
          pageSize: this.pageSize,
          currentPage: this.currentPage
        })
      });
    },
    getParamsCookie() {
      const prams = getCookie({ key: "vipCardListParams", type: "session" });
      if (prams) {
        let search = {};
        for (let key in prams) {
          if (key !== "pageSize" && key !== "currentPage") {
            search[key] = prams[key];
          }
        }
        this.searchCondition = search;
        this.pageSize = prams.pageSize;
        this.currentPage = prams.currentPage;
      }
    },
    getChecked(selection) {
      this.checkedRow = selection.map(v => v.memberCardId);
      this.num = selection.length;
    },
    getCheckedEmployee(selection) {
      this.checkedEmployee = selection.employeeId;
    },
    batchSetting() {
      if (this.checkedRow.length) {
        this.dialogVisible = true;
      } else {
        this.$message({
          message: "请选择批量项",
          type: "warning"
        });
      }
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    pagingEmployee(page) {
      this.currentEmployeePage = page;
      this.queryEmployeeList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    handleSizeEmployeeChange(size) {
      this.currentEmployeePage = 1;
      this.pageEmployeeSize = size;
      this.queryEmployeeList();
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    }
  }
};
</script>
